/** Foxi időzítéseinek (5 mezős cron) emberi nyelvű leírása — a gyakori mintákra; különben maga a cron. */
const DAYS = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'];
const DAYS_ON = ['vasárnaponként', 'hétfőnként', 'keddenként', 'szerdánként', 'csütörtökönként', 'péntekenként', 'szombatonként'];

function times(min: string, hour: string): string | null {
  if (!/^\d+$/.test(min) || !/^[\d,]+$/.test(hour)) return null;
  return hour
    .split(',')
    .map((h) => `${Number(h)}:${min.padStart(2, '0')}`)
    .join(' és ');
}

export function describeCron(cron: string): string {
  const parts = `${cron || ''}`.trim().split(/\s+/);
  if (parts.length !== 5) return cron;
  const [min, hour, dom, mon, dow] = parts;
  if (dom !== '*' || mon !== '*') {
    if (mon === '*' && /^\d+$/.test(dom)) {
      const t = times(min, hour);
      if (t && dow === '*') return `minden hónap ${dom}. napján ${t}`;
    }
    return cron;
  }
  if (hour === '*' && dow === '*') {
    if (min === '0') return 'óránként';
    const every = min.match(/^\*\/(\d+)$/);
    if (every) return `${every[1]} percenként`;
    if (/^\d+$/.test(min)) return `óránként, :${min.padStart(2, '0')}-kor`;
  }
  const everyH = hour.match(/^\*\/(\d+)$/);
  if (everyH && /^\d+$/.test(min) && dow === '*') return `${everyH[1]} óránként`;
  const range = hour.match(/^(\d+)-(\d+)$/);
  if (range && min === '0') {
    const base = `óránként ${range[1]}–${range[2]} óra között`;
    return dow === '1-5' ? `hétköznap ${base}` : dow === '*' ? base : cron;
  }
  const t = times(min, hour);
  if (!t) return cron;
  if (dow === '*') return `naponta ${t}`;
  if (dow === '1-5') return `hétköznap ${t}`;
  if (dow === '0,6' || dow === '6,0') return `hétvégén ${t}`;
  if (/^\d$/.test(dow)) return `${DAYS_ON[Number(dow) % 7]} ${t}`;
  if (/^[\d,]+$/.test(dow)) return `${dow.split(',').map((d) => DAYS[Number(d) % 7]).join(', ')} ${t}`;
  return cron;
}
